const STORAGE_TYPE = 'session';

class ShopUserService {
    /*@ngInject*/
    constructor($rootScope, fpStore, constants, dataContext, $q) {
        this.$rootScope = $rootScope;
        this._store = fpStore;
        this._key = constants.userStorage;
        this.$q = $q;
        this.dataContext = dataContext;
    }

    get() {
        if (this._store.has(this._key, STORAGE_TYPE))
            return this.$q.when(this._store.get(this._key, STORAGE_TYPE));
        else {
            return this.dataContext.user.getUserInfo()
                .then((result) => {
                    this._store.set(this._key, result, STORAGE_TYPE);
                    return result;
                });
        }
    }

    reset() {
        this._store.remove(this._key, STORAGE_TYPE);
    }
}

export default ShopUserService;